'use strict';

require('../../modules/helpers/frontend/mpp_namespace');

require('../../modules/helpers/frontend/trim');

require('../../modules/helpers/frontend/vendor/jquery.scrollTo.js');

require('../../modules/merchant_page/frontend/lib/jquery.jcarousel.js'); // alphabetical order unless there's a specific requirement not to do so

require('../../modules/merchant_page/frontend/biz');

require('../../modules/consumer_intercept_survey/frontend/survey.js');

require('../../modules/coupons/frontend/coupons');

require('../../modules/deal_carousel/frontend/deal_carousel');

require('../../modules/edit_information/frontend/edit_information');

require('../../modules/follow_merchant/frontend/follow_merchant');

require('../../modules/groupon-iframe-login/frontend/iframe_login');

require('../../modules/helpers/frontend/iframe_login_override');

require('../../modules/header/frontend/parallax');

require('../../modules/megamind_widgets/frontend/main');

require('../../modules/merchant_information/frontend/mobile_map_modal');

require('../../modules/merchant_photos/frontend/photo_widget');

require('../../modules/merchant_videos/frontend/merchant_videos');

require('../../modules/multiple_offers/frontend/multiple_offers');

require('../../modules/nearby_deals/frontend/desktop');

require('../../modules/offers_map/frontend/main');

require('../../modules/recommendations/frontend/recommendations');

require('../../modules/request_deal/frontend/request_deal');

require('../../modules/sharing/frontend/main');

require('../../modules/small_map/frontend/small_map');

require('../../modules/tips/frontend/tips'); // Remember to call Groupon.Performance.pageReady() when the page is completely
// loaded. This will send performance data to Optimize.
//
// More context is available at:
// https://pages.github.groupondev.com/InteractionTier/framework/optimize.html
//
// Sample code:
// $(window).on 'load', ->
//   Groupon.Performance.pageReady()
